import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheHabitHero from "./sections/TheHabitHero";
import OurTrustedPartners from "./sections/OurTrustedPartners";
import ReliabilityByTheNumbers from "./sections/ReliabilityByTheNumbers";
import MainServices from "./sections/MainServices";
import VoicesOfSecurity from "./sections/VoicesOfSecurity";
import ReadyToReconnect from "./sections/ReadyToReconnect";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheHabitHero />
      <OurTrustedPartners />
      <ReliabilityByTheNumbers />
      <MainServices />
      <VoicesOfSecurity />
      <ReadyToReconnect />
      <Footer />
    </div>;
}